import bridge from './bridge'
/**
 * 注册bridge桥
 */
export default {
  install (Vue) {
    Vue.use(bridge)
  }
}
